import Cookies from 'js-cookie';

export default class CookiesNotice {
	constructor(container) {
		this.container = container;

		if (!this.container) return;

		this.container.querySelector('button').addEventListener('click', () => {
			let date = new Date();
			date.setFullYear(date.getFullYear() + 2);
			Cookies.set('cookies_accepted', 'true', { expires: date });
			this.container.classList.add('hidden');
		});
	}
}
